import axios from 'axios'

export default {
    getTopCategories() {
        return axios.get(process.env.VUE_APP_BACKEND_BASE_URL + '/categories').then((response) => {
            return response
        })
    },
    getCategoriesByParent(parentId) {
        return axios.get(process.env.VUE_APP_BACKEND_BASE_URL + '/categories/' + parentId).then((response) => {
            return response
        })
    },
    getCategoriesByInput(input) {
        return axios.get(process.env.VUE_APP_BACKEND_BASE_URL + '/categories/input/' + encodeURIComponent(input)).then((response) => {
            return response
        })
    },
    getAssignableCategories() {
        return axios.get(process.env.VUE_APP_BACKEND_BASE_URL + '/categories/show/assignable').then((response) => {
            return response
        })
    },
    deleteCategory(categoryId) {
        return axios.delete(process.env.VUE_APP_BACKEND_BASE_URL + '/categories/' + categoryId).then((response) => {
            return response
        })
    },
    createCategory(category) {
        return axios.post(process.env.VUE_APP_BACKEND_BASE_URL + '/categories', category).then((response) => {
            return response
        })
    },
    updateCategory(category) {
        return axios.put(process.env.VUE_APP_BACKEND_BASE_URL + '/categories', category).then((response) => {
            return response
        })
    },
    switchCategory(category) {
        return axios.post(process.env.VUE_APP_BACKEND_BASE_URL + '/categories/switch', category).then((response) => {
            return response
        })
    },
    saveCategoryInfo(info) {
        return axios.post(process.env.VUE_APP_BACKEND_BASE_URL + '/categories/info', info).then((response) => {
            return response
        })
    },
    getCategoryInfo(categoryId) {
        return axios.get(process.env.VUE_APP_BACKEND_BASE_URL + '/categories/info/' + categoryId).then((response) => {
            return response
        })
    }
}
